// extracted by mini-css-extract-plugin
export default {"mainContainer":"MinistryRescriptHistoryTable_mainContainer__sMOjP"};